import * as yup from 'yup'
import resolveErrorById, { POLICY_NOT_CONFIRMED, TYPE_EMAIL_INVALID, TYPE_REQUIRED, TYPE_UNMATCHED_PASSWORD } from 'constants/errors'
import { ENFORCE_POLICY_AGREEMENT } from 'constants/onboarding'
import { schemaString } from 'schemas/baseSchema'
import { fullNameSchema, YupShape } from 'helpers/schemaHelpers'

export const EMAIL_SCHEMA = yup.object().shape({
  email: yup.string().email(TYPE_EMAIL_INVALID).required(TYPE_REQUIRED),
})

export const policyValidatorCreator = (asSyncValidator: boolean) => (value: boolean): boolean | string | undefined => {
  const isValid = ENFORCE_POLICY_AGREEMENT ? value : true
  if (asSyncValidator) {
    return isValid ? undefined : resolveErrorById(POLICY_NOT_CONFIRMED)
  }

  return isValid
}

type RegisterForm = {
  first_name: string
  last_name: string
  password: string
  email: string
  password_confirm: string
  policy: boolean
}

const registerStep = {
  first_name: fullNameSchema,
  last_name: fullNameSchema,
  email:  yup.string().email(TYPE_EMAIL_INVALID).required(TYPE_REQUIRED),
  password: schemaString,
  password_confirm: schemaString
    .test('passwords-match', TYPE_UNMATCHED_PASSWORD, function arePasswordsMatch () {
      return this.parent.password === this.parent.password_confirm
    }),
  policy: yup.boolean()
    .test(
      'policy-confirmed',
      resolveErrorById(POLICY_NOT_CONFIRMED),
      policyValidatorCreator(false) as (value: any) => boolean,
    ) as yup.BooleanSchema<boolean, object>,
}

export const registerFormSchema = yup.object().shape<YupShape<RegisterForm>>(registerStep)

export default registerFormSchema
